import { ApiClient } from '@/src/api/ApiClient';
import { QueryParams } from '@/src/api/types';
import { FetchLabDashboardResponse } from '@/src/types/LabDashboard';
import { i18nKeys } from '@/src/utils/i18n.utils';
import { TFunction } from 'i18next';

export class LabDashboardAPI {
  private static ROOT_PATH = '/admin/labs/dashboard';

  constructor(private apiClient: ApiClient, private t: TFunction) {
    // do nothing
  }

  /**
   * Fetch the lab dashboard summary for a given month.
   */
  public async fetchLabDashboard(monthYear: string): Promise<FetchLabDashboardResponse> {
    const params: QueryParams = {};
    params.month = monthYear;

    return this.apiClient.get({
      path: `${LabDashboardAPI.ROOT_PATH}`,
      failMessage: this.t(i18nKeys.labDashboard.messages.failedFetchDashboard),
      params,
      responseMapper: (object) => object as FetchLabDashboardResponse,
    });
  }
}
